import { Component, Inject, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as htmlToImage from 'html-to-image';

@Component({
  selector: 'app-coin-detail-capture',
  templateUrl: './coin-detail-capture.component.html',
  styleUrls: ['./coin-detail-capture.component.scss'],
  standalone: false,
})
export class CoinDetailCaptureComponent implements AfterViewInit {
  @ViewChild('captureDiv') captureDiv!: ElementRef;
  isDownloading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { frontImageUrl: string; backImageUrl: string; coin: any },
    private dialogRef: MatDialogRef<CoinDetailCaptureComponent>
  ) {}

  ngAfterViewInit() {
 
    setTimeout(() => {
      this.downloadImage();
    }, 500);
  }

  downloadImage() {
    if (!this.captureDiv) {
      console.error('Capture div not found');
      return;
    }

    this.isDownloading = true;

    htmlToImage.toPng(this.captureDiv.nativeElement, {
      quality: 1.0,
      pixelRatio: 2,
      cacheBust: true,
    })
    .then((dataUrl) => {
      const link = document.createElement('a');
      link.download = `coin-detail-${Date.now()}.png`;
      link.href = dataUrl;
      link.click();
      
 
      setTimeout(() => {
        this.isDownloading = false;
        this.dialogRef.close();
      }, 1000); 
    })
    .catch((error) => {
      console.error('Error generating image:', error);
      this.isDownloading = false;
    });
  }
}
